export default () => {
  const sliderParents = document.querySelectorAll('.js-slider-container')


  if (sliderParents.length < 1) return



  ;[...sliderParents].forEach(sliderParent => {
    // Variables
    const slides = sliderParent.querySelectorAll('.js-slide')
    const dots = sliderParent.querySelectorAll('.js-dot')
    const next = sliderParent.querySelector('.js-next')
    const prev = sliderParent.querySelector('.js-prev')

    const slidesCount = slides.length
    const firstSlide = slides[0]
    let pos = 0

    ;[...slides].forEach(slide => {
      slide.style.opacity = '0'
      slide.style.display = 'none'
    })
    firstSlide.style.opacity = '1'
    firstSlide.style.display = 'flex'
    prev.style.display = 'none'
    dots[0].style.opacity = '1'

    // Events
    prev.addEventListener('click', () => {
      goPrev()
    })

    next.addEventListener('click', () => {
      goNext()
    })

    document.addEventListener('keydown', e => {
      if (e.keyCode === 39) {
        goNext()
      }
      if (e.keyCode === 37) {
        goPrev()
      }
    })
    ;[...dots].forEach(function(dot, index) {
      dot.addEventListener('click', () => {
        navActivity(index)
        pos = index
      })
    })

    //functions
    function goPrev() {
      if (pos > 0) {
        pos--
        navActivity(pos)
      }
    }

    function goNext() {
      if (pos < slidesCount - 1) {
        pos++
        navActivity(pos)
      }
    }

    function navActivity(pos) {
      ;[...slides].forEach(slide => {
        slide.style.opacity = '0'
        setTimeout(function() {
          slide.style.display = 'none'
        }, 300)
      })
      ;[...dots].forEach(dot => {
        dot.style.opacity = '.5'
      })

      dots[pos].style.opacity = '1'

      setTimeout(function() {
        slides[pos].style.display = 'flex'
      }, 300)

      setTimeout(function() {
        slides[pos].style.opacity = '1'
      }, 350)

      if (pos === 0) {
        prev.style.display = 'none'
      } else {
        prev.style.display = 'flex'
      }

      if (pos === slidesCount - 1) {
        next.style.display = 'none'
      } else {
        next.style.display = 'flex'
      }
    }
  }) // end foreach
}



// WEBPACK FOOTER //
// ./src/js/modules/Slider.js